// Shared constants for profile options across the app

// Motherhood phases
export const PHASES = [
  { value: "ttc", label: "Trying to Conceive", description: "Tracking cycles, doctor visits, and the pursuit of motherhood", icon: "Sparkles", color: "clay" },
  { value: "pregnant", label: "Pregnant (First Time)", description: "Navigating your first pregnancy journey", icon: "Heart", color: "sage" },
  { value: "pregnant-again", label: "Pregnant Again", description: "Expecting another little one while parenting", icon: "Heart", color: "sage" },
  { value: "postpartum", label: "Postpartum", description: "Embracing the new chapter after birth", icon: "Baby", color: "purple" },
  { value: "pausing", label: "Pausing", description: "Taking a break from the journey", icon: "Heart", color: "sage" },
  { value: "grieving", label: "Grieving", description: "Processing loss and healing", icon: "Heart", color: "clay" },
  { value: "undecided", label: "Undecided", description: "Still figuring out what's next", icon: "Brain", color: "sage" },
  { value: "confused", label: "Confused", description: "Feeling uncertain about the path ahead", icon: "Brain", color: "clay" },
  { value: "other", label: "Other", description: "My journey is unique", icon: "Star", color: "purple" }
];

// Phases that should show children info
export const PHASES_WITH_CHILDREN_INFO = ["ttc", "pregnant", "pregnant-again", "postpartum"];

// Children/Motherhood journey info options - varies by phase
export const CHILDREN_INFO_OPTIONS = {
  ttc: [
    { value: "first-time-trying", label: "First Time Trying" },
    { value: "trying-again", label: "Trying for Another" },
    { value: "trying-after-loss", label: "Trying After Loss" }
  ],
  pregnant: [
    { value: "first-time-expecting", label: "First-Time Expecting" }
  ],
  "pregnant-again": [
    { value: "one-child-expecting", label: "Mom of One, Expecting Again" },
    { value: "two-children-expecting", label: "Mom of Two, Expecting Again" },
    { value: "three-plus-expecting", label: "Mom of 3+, Expecting Again" },
    { value: "twins-expecting", label: "Twin Mom, Expecting Again" }
  ],
  postpartum: [
    { value: "first-time-mom", label: "First-Time Mom" },
    { value: "one-child", label: "Mom of One" },
    { value: "two-children", label: "Mom of Two" },
    { value: "three-plus", label: "Mom of 3+" },
    { value: "twins", label: "Twin Mom" },
    { value: "triplets-plus", label: "Triplets or More" }
  ]
};

// Get children info options based on phase
export const getChildrenInfoOptionsForPhase = (phase) => {
  return CHILDREN_INFO_OPTIONS[phase] || [];
};

// Working status options
export const WORKING_STATUS_OPTIONS = [
  { value: "working-full-time", label: "Working Full-Time" },
  { value: "working-part-time", label: "Working Part-Time" },
  { value: "stay-at-home", label: "Stay-at-Home Mom" },
  { value: "maternity-leave", label: "On Maternity Leave" },
  { value: "freelance", label: "Freelance/Self-Employed" },
  { value: "looking-for-work", label: "Looking for Work" },
  { value: "student", label: "Student" }
];

// Help topics for looking for help / willing to help
export const HELP_TOPICS = [
  "Sleep Training",
  "Breastfeeding", 
  "Formula Feeding",
  "Work-Life Balance",
  "Mental Health",
  "Postpartum Recovery",
  "Newborn Care",
  "Toddler Parenting",
  "Fertility",
  "Pregnancy",
  "Birth Preparation",
  "Twin/Multiple Parenting",
  "Nutrition",
  "Exercise & Fitness",
  "Relationships",
  "Career Advice"
];

// Default interests
export const DEFAULT_INTERESTS = [
  "Fitness & Yoga",
  "Nutrition", 
  "Mental Health",
  "Sleep & Rest",
  "Breastfeeding",
  "Baby Care",
  "Work-Life Balance",
  "Relationships",
  "Self Care",
  "Natural Remedies",
  "Medical Support",
  "Community Events"
];

// Helper functions
export const getPhaseLabel = (phase) => {
  const found = PHASES.find(p => p.value === phase);
  return found?.label || phase || 'Not set';
};

export const getWorkingStatusLabel = (status) => {
  const found = WORKING_STATUS_OPTIONS.find(o => o.value === status);
  return found?.label || status || 'Not set';
};

export const getChildrenInfoLabel = (info) => {
  // Search across all phase options
  for (const phaseOptions of Object.values(CHILDREN_INFO_OPTIONS)) {
    const found = phaseOptions.find(o => o.value === info);
    if (found) return found.label;
  }
  return info || 'Not set';
};
